import { render, staticRenderFns } from "./GenericToggleButton.vue?vue&type=template&id=5d348452"
import script from "./GenericToggleButton.vue?vue&type=script&lang=ts"
export * from "./GenericToggleButton.vue?vue&type=script&lang=ts"
import style0 from "./GenericToggleButton.vue?vue&type=style&index=0&id=5d348452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports